import Vue from 'vue'
import VueCarousel from 'vue-carousel'

import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/tailwind.css'

Vue.config.productionTip = false
Vue.use(VueCarousel)

new Vue({
  store, 
  router,
  render: h => h(App),
}).$mount('#app')
